export default "/static/inheco_scila_tiny.png";